import src from "IMAGE";
export default { src, width: 240, height: 72, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AISFhnliY2RYf4GCdD09PTRGRkY7NjY2LERERDogICAbAH6AgHGPkpOAZ2lrXzQ0NC1dXV1QaGhoVnJycmNnZ2da4g4WijXNVSMAAAAASUVORK5CYII="};
